import { render } from "./ChartOfAccountsSetupModal.vue?vue&type=template&id=d496f5fe"
import script from "./ChartOfAccountsSetupModal.vue?vue&type=script&lang=js"
export * from "./ChartOfAccountsSetupModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__